import { render, staticRenderFns } from "./WorkAutocompleteLazy.vue?vue&type=template&id=1f5a5222&scoped=true"
import script from "./WorkAutocompleteLazy.vue?vue&type=script&lang=js"
export * from "./WorkAutocompleteLazy.vue?vue&type=script&lang=js"
import style0 from "./WorkAutocompleteLazy.vue?vue&type=style&index=0&id=1f5a5222&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5a5222",
  null
  
)

export default component.exports